import { MultipleChoiceGroup } from '@ulysses-inc/harami_api_client'
import { useQueryRelatedTemplates } from '../api/useQueryRelatedTemplates'

/**
 * 選択肢グループを使用している関連ひな形の情報を取得する
 */
export const useMultipleChoiceGroupRelatedTemplates = (
  multipleChoiceGroupForUpdate: MultipleChoiceGroup | undefined,
) => {
  const multipleChoiceGroupId = multipleChoiceGroupForUpdate?.id
  // 編集モード（multipleChoiceGroupIdが存在）の場合のみAPIリクエストを実行
  // 新規作成モードでは関連ひな形の取得は不要
  const enabled = !!multipleChoiceGroupId

  const {
    data: relatedTemplates,
    isFetching: isFetchingRelatedTemplates,
    isError: isErrorRelatedTemplates,
  } = useQueryRelatedTemplates(multipleChoiceGroupId, enabled)

  return {
    relatedTemplates,
    isFetchingRelatedTemplates,
    isErrorRelatedTemplates,
  }
}
